import { render, staticRenderFns } from "./MyDonationsView.vue?vue&type=template&id=41b53429&scoped=true&"
import script from "./MyDonationsView.vue?vue&type=script&lang=js&"
export * from "./MyDonationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b53429",
  null
  
)

export default component.exports